// @ts-check

import { fetchContacts } from '@/data/api/contacts';

/** @typedef {import('@/queries/contacts/queryKeys').TAllContactsKey} TAllContactsKey */
/** @typedef {import('@/queries/contacts/queryKeys').TSearchContactsKey} TSearchContactsKey */

/**
 * Queries the contacts based on the provided parameters.
 *
 * @param {Object} options - The options for the query.
 * @param {TAllContactsKey|TSearchContactsKey} options.queryKey - The query key.
 * @param {AbortSignal} options.signal - The signal used to abort the request.
 */
export function queryContacts({ queryKey, signal }) {
  const [, query] = queryKey;
  return fetchContacts({ query: query || '', page: 1, signal });
}
